import { useEffect, useState } from 'react';
import { NavButton, RewardContainer, Title, TopContainer } from './Dashboard.styled';
import { useStore } from '@store/appStore';
import db from '@utils/db';
import RainbowLoader from '@components/Loaders/RainbowLoader';
import { useI18n } from '@i18n/useI18n';
import { GridCard } from '@components/GridCards/Common.styled';
import RewardItem from '../RewardItem';
import Rewards from '@models/Rewards';
import useMeasureCols from '@hooks/useMeasureCols';
import moment from 'moment';
import Log from '../Log';

interface IProps {
  setNav: (number) => void;
  rewards: Array<any>;
  setEditItem: (number) => void;
  logs: any;
}

const Dashboard = (props: IProps) => {
  const i18n = useI18n();
  const { callNameSetting, adminSelection, adminSelectedStudent, clientSettings, systemSettings } = useStore();
  let colWidth = useMeasureCols(160, 20);
  useEffect(() => {}, []);

  let temploop = [];

  for (let index = 0; index < props.rewards.length; index++) {
    temploop.push(<RewardItem key={index} setEditItem={props.setEditItem} rewardItem={props.rewards[index]} />);
  }

  return (
    <>
      <GridCard col={4} heightAuto={true}>
        <TopContainer>
          <Title>{i18n.t('menu-rewardpage')}</Title>
          <NavButton onClick={() => props.setNav(1)}>{i18n.t('reward-create')}</NavButton>
        </TopContainer>
        <RewardContainer col={colWidth}>{temploop}</RewardContainer>
      </GridCard>
      <GridCard col={4} heightAuto={true}>
        <TopContainer>
          <Title>{i18n.t('log')}</Title>
        </TopContainer>
        {props.rewards.map((m, index) => (
          <Log key={index + 'Logs'} list={props.logs} rewardId={m.id} rewardTitle={m.title} />
        ))}

        {/* {props.logs?.map((l) => (
            <LogItem>
              <span>{l.title} </span>
              <span>{l.clerk} </span>
              <span>{moment(l.timestamp).format('hh:mm - DD-MM-YY')}</span>
              <span>{l.description} </span>
              <span>{l.customer} </span>
              <span>{l.amount} </span>
            </LogItem>
          ))} */}
      </GridCard>
    </>
  );
};

export default Dashboard;
